import script from "./single-file-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./single-file-upload.vue?vue&type=script&setup=true&lang=js"

import "./single-file-upload.vue?vue&type=style&index=0&id=251bf1fe&lang=postcss&scoped=true"
/* custom blocks */
import block0 from "./single-file-upload.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251bf1fe"]])

export default __exports__